/**
 * Reasoning-phase accumulation for the live case-panel SSE stream.
 *
 * Produces the same separator-joined output as the backend's `append_thinking_phase`
 * (agent_runner.py) so a message looks identical whether live-streaming or reloaded;
 * the frontend additionally handles incremental delta events the backend does not encounter.
 */

/** Separator between reasoning phases. Must match backend `THINKING_PHASE_SEPARATOR`. */
export const THINKING_PHASE_SEPARATOR = '\n\n---\n\n'

/** Buffer prefix when a new phase begins: prior text + separator, or empty for the first phase. */
export const beginThinkingPhase = (buffer: string): string =>
  buffer ? buffer + THINKING_PHASE_SEPARATOR : ''

/**
 * Finalize a reasoning phase. Three cases:
 * 1. `phase` is empty — no content to add; return `buffer` unchanged regardless of delta state
 *    (emptiness alone short-circuits, whether or not deltas moved the buffer past `base`).
 * 2. Deltas streamed the phase (`buffer !== base`) — `buffer` already holds it; return as-is,
 *    ignoring the redundant complete payload.
 * 3. No deltas arrived (`buffer === base`) — append the phase from `thinking_complete`.
 */
export const finalizeThinkingPhase = (buffer: string, base: string, phase: string): string =>
  phase && buffer === base ? base + phase : buffer
